import React, { useContext } from "react";
import RegistrationPageContext from './RegistratioPageContext';
import { store } from "../../store";
import { getDic } from "../../assets/i18n/dictionary";
import ShowZendesk from '../../services/zendeskService';

//Imports de components
import {
  Container,
  FormColumn,
  FormRow,
  TextBig,
  TextSmall,
  Card,
  InputFieldOutlined,
  Button,
  ActivityIndicator,
  SelectList,
  Alert,
  Loading,
  Recaptcha,
  IframePlayer,
  DefaultTerm,
  Modal,
  Link,
  TextMedium,
  Checkbox
} from "../../components";

const RegistrationPageVisual = (props) => {
  // Busca o state e os métodos e instancia em uma variável context
  const { state, functions } = useContext(RegistrationPageContext);

  const renderModalNovartis = () => {
    if (!state.showModalNovartis) {
      return null;
    }

    return (
      <FormColumn margin="0px" padding='5px' width="98%" align="center">
        <FormRow margin="0px">
          <TextSmall textAlign="justify" fontSize="10px">
            <b>COSENTYX®</b> secuquinumabe VIA SUBCUTÂNEA
          </TextSmall>
        </FormRow>
        <FormRow margin="0px">
          <TextSmall textAlign="justify" fontSize="10px">
            <a target='blank' href="https://portal.novartis.com.br/medicamentos/wp-content/uploads/2021/10/Bula-COSENTYX-Solucao-Injetavel-Medico.pdf">Clique</a> para ler a bula de COSENTYX® na íntegra.
          </TextSmall>
        </FormRow>
        <FormRow margin="0px">
          <TextSmall textAlign="justify" fontSize="10px">
            <b>Contraindicações</b>: Cosentyx® é contraindicado em pacientes com reações graves de hipersensibilidade ao princípio ativo ou a qualquer um dos excipientes. Interações Medicamentosas: Vacinas de vírus vivos não devem ser administradas concomitantemente com Cosentyx®. Em um estudo em pacientes com psoríase em placas, não foi observada interação entre secuquinumabe e midazolam (substrato CYP3A4).
          </TextSmall>
        </FormRow>
        <FormRow margin="0px">
          <TextSmall textAlign="justify" fontSize="10px">
            Referências: 1. Blauvelt A, Reich K, Tsai TF, et al. Secukinumab is superior to ustekinumab in clearing skin of subjects with moderate-to-severe plaque psoriasis up to 1 year: Results from the CLEAR study. J Am Acad Dermatol. 2017;76:60-9. 2. Kimball AB, Jemec GBE, Alavi A, et al. Secukinumab in moderate-to-severe hidradenitis suppurativa (SUNSHINE and SUNRISE): week 16 and week 52 results of two identical, multicentre, randomised, placebo-controlled, double-blind phase 3 trials. Lancet. 2023 Mar 4;401(10378):747-761. Epub 2023 Feb 3. PMID: 36746171. 3. Mease P, van der Heijde D, Landewé R, et al. Secukinumab improves active psoriatic arthritis symptoms and inhibits radiographic progression: primary results from the randomised, double-blind, phase III FUTURE5 study. Ann Rheum Dis. 2018 Jun;77(6):890-897. 4. Baraliakos X, Gossec L, Pournara E, et al.  Ann Rheum Dis. 2021 May;80(5):582-590. 5. A. Deodhar, P.G. Conaghan, T.K. Kvien et al. Clinical and Experimental Rheumatology. 2018 Jul 19. 6. Poddubnyy D, Pournara E, Zielińska, et al. Ther Adv Musculoskelet Dis. 2021 Oct 22;13:1759720X211051471. 7. Augustin M, Dauden E, Mrowietz U, et al.  J Eur Acad Dermatol Venereol. 2021 Feb;35(2):431-440.  Epub 2020 Jul 1. 8. Kimball AB, Jemec GBE, Alavi A, et al. Lancet. 2023 Mar 4;401(10378):747-761. Epub 2023 Feb 3. PMID: 36746171. *O termo "visível" refere-se às manifestações da psoríase em placas moderada à grave (psoríase cutânea) e da hidradenite supurativa ativa, que são visíveis na pele na forma de lesões, nódulos e abcessos. Por outro lado, "invisível" refere-se às manifestações não visíveis da artrite psoriásica ativa e espondilite anquilosante ativa, como dor, impacto na qualidade de vida e acometimento articular. Também inclui o impacto na qualidade de vida causado pela hidradenite supurativa ativa e psoríase em placas moderada à grave.
          </TextSmall>
        </FormRow>
        <FormRow margin="0px">
          <TextSmall textAlign="justify" fontSize="10px">
            Material dirigido unicamente a profissionais da saúde habilitados a prescrever medicamentos. Data de Produção: Abril/2025. © Direitos reservados - 2025 . Novartis Biociências S/A - Proibida a impressão e reprodução total ou parcial. BR-XXXXX.
          </TextSmall>
        </FormRow>
        <FormRow margin="0px">
          <TextSmall textAlign="justify" fontSize="10px">
            Para reportar um evento adverso entre em contato por meio do Serviço de Informações ao Cliente (SIC) sic.novartis@novartis.com ou 0800 888 3003. Novartis Biociências S.A. Setor Farma - Av. Prof. Vicente Rao, 90 São Paulo, SP - CEP 04636-000 | www.novartis.com.br | www.portal.novartis.com.br. SIC - Serviço de Informações ao Cliente 0800 888 3003 | sic.novartis@novartis.com.
          </TextSmall>
        </FormRow>
      </FormColumn>
    )
  }

  const renderCardContent = () => {
    return (
      <FormColumn align="center">
        <FormRow align="center">
          <div style={{ width: "100%", maxWidth: "600px" }}>
            <img alt="" src={state.image001} style={{ width: "100%" }} />
          </div>
        </FormRow>
        <TextBig
          fontSize={state.primaryTitle.size}
          color={state.primaryTitle.color}
        >
          {state.primaryTitle.text}
        </TextBig>
        <TextSmall
          fontSize={state.secondaryTitle.size}
          color={state.secondaryTitle.color}
        >
          {state.secondaryTitle.text}
        </TextSmall>
        <br />
        <FormRow align="left" margin="10px">
          <TextSmall
            color={state.tittle005.color}
            fontSize={state.tittle005.size}
          >
            {state.tittle005.text}
          </TextSmall>
        </FormRow>
        {state.attributesValueList.map((item) => {
          if (
            state.hasPassword &&
            (
              item.dbReference === 'Senha' ||
              item.dbReference === 'Email'
            )
          ) {
            return null;
          }

          if (
            item.id?.toString() === state.terms2.termId
            || item.id?.toString() === state.terms3.termId
            || item.id?.toString() === state.terms4.termId
          ) {
            return null;
          }
          if (item.type === "select" && item.values) {
            return (
              <FormRow key={item.id} align="center" paddingTop="5px">
                <SelectList
                  required={item.required}
                  error={item.error}
                  errorMessage={item.errorMessage}
                  title={item.name}
                  width="100%"
                  value={item.value}
                  menuItens={item.values}
                  onChange={async (event) =>
                    functions.onChangeHandler(item.id, event.target.value)
                  }
                  disabled={item.disabled}
                />
              </FormRow>
            );
          }
          if (item.type === "text") {
            return (
              <FormRow key={item.id} align="center" paddingTop="5px">
                <InputFieldOutlined
                  key={item.id}
                  required={item.required}
                  maxLength={item.maxLength}
                  error={item.error}
                  errorMessage={item.errorMessage}
                  value={item.value}
                  title={item.name}
                  onChange={(event) =>
                    functions.onChangeHandler(item.id, event.target.value)
                  }
                  onKeyPress={(event) => functions.onKeyPressHandler(event.key)}
                  mask={item.mask}
                  disabled={item.disabled}
                />
              </FormRow>
            );
          }
        })}
        {state.hasPassword && (
          <>
            <FormRow align="center" paddingTop="5px">
              <InputFieldOutlined
                type="password"
                required={true}
                error={state.passwordControl1.error}
                errorMessage={state.passwordControl1.errorMessage}
                value={state.passwordControl1.value}
                title={`${getDic("senha")}`}
                onChange={(e) =>
                  state.setPasswordControl1({ ...state.passwordControl1, value: e.target.value })
                }
              />
            </FormRow>
            <FormRow align="center" paddingTop="5px">
              <InputFieldOutlined
                type="password"
                required={true}
                error={state.passwordControl2.error}
                errorMessage={state.passwordControl2.errorMessage}
                value={state.passwordControl2.value}
                title={`${getDic("confirmar")} ${getDic("senha")}`}
                onChange={(e) =>
                  state.setPasswordControl2({ ...state.passwordControl2, value: e.target.value })
                }
              />
            </FormRow>
          </>
        )}
        {state.hasLang && (
          <div
            style={{
              textAlign: "left",
              paddingBottom: "10px",
              paddingTop: "10px",
            }}
          >
            <SelectList
              title={`${getDic('selecione')} ${getDic('idioma')}`}
              width="50%"
              value={state.language}
              menuItens={state.languages}
              onChange={async (e) => functions.changeLanguage(e.target.value)}
            />
          </div>
        )}
        {state.useRecaptcha && (
          <FormRow align="flex-end" margin="0px" paddingTop="10px">
            <Recaptcha
              onChange={(res) => state.setRecaptchaVerify(res)}
            />
          </FormRow>
        )}
        {renderTermsField()}
        {renderTermsField2()}
        {renderTermsField3()}
        {renderTermsField4()}
        <br />
        <Button
          text={state.buttonText}
          color={state.buttonColor}
          onClick={(event) => functions.tryRegister()}
        />
        <br />
        <FormRow align="center" margin="0px">
          <div style={{ width: "100%" }}>
            <img alt="" src={state.image003} style={{ width: "100%" }} />
          </div>
        </FormRow>
      </FormColumn>
    );
  }

  if (state.isLoading) {
    return (
      <Container background="#e8eced" align="center">
        <FormRow align="center">
          <ActivityIndicator />
        </FormRow>
      </Container>
    );
  }
  return (
    <Container background={state.colorBackGround} align="center" heigth="100%">
      <FormColumn
        margin="0px"
        backgroundImage={state.imageBackgroundUrl}
        backgroundSize="100% 100%"
      >
        <div style={{ position: "relative", width: "100%", height: "100vh", overflow: "auto" }}>
          <div className="admin-dashboard">
            <FormRow
              align="center"
              background={state.colorBackGround}
              margin="0px"
              paddingBottom="10px"
            >
              <div
                style={{
                  width: window.innerWidth < 600 ? `${window.innerWidth}px` : "600px",
                  textAlign: "center",
                  marginTop: "10px",
                }}
              >
                {!state.cardConfig ? (
                  <Card>{renderCardContent()}</Card>
                ) : state.cardConfig === "CARD-SIMP" ? (
                  <Card cardType="simple">{renderCardContent()}</Card>
                ) : (
                  <Card cardType="transparent">{renderCardContent()}</Card>
                )}
              </div>
            </FormRow>

            <Alert
              open={state.alertOpen}
              onClose={() => state.setAlertOpen(false)}
              onClick={() => state.setAlertOpen(false)}
              title={state.alertTitle}
              message={state.alertMessage}
            />

            <Modal
              isVideo
              open={state.openModalTerms}
              closeButtonClick={(e) => {
                state.setOpenModalTerms(false);
              }}
              onClose={(ret) => {
                state.setOpenModalTerms(false);
              }}
            >
              <Container background="#e8eced" align="left" height="100%">
                {renderTerms()}
              </Container>
            </Modal>

            <Modal
              isVideo
              open={state.openModalTerms2}
              closeButtonClick={(e) => {
                state.setOpenModalTerms2(false);
              }}
              onClose={(ret) => {
                state.setOpenModalTerms2(false);
              }}
            >
              <Container background="#e8eced" align="left" height="100%">
                {renderTerms2()}
              </Container>
            </Modal>

            <Modal
              isVideo
              open={state.openModalTerms3}
              closeButtonClick={(e) => {
                state.setOpenModalTerms3(false);
              }}
              onClose={(ret) => {
                state.setOpenModalTerms3(false);
              }}
            >
              <Container background="#e8eced" align="left" height="100%">
                {renderTerms3()}
              </Container>
            </Modal>

            <Modal
              isVideo
              open={state.openModalTerms4}
              closeButtonClick={(e) => {
                state.setOpenModalTerms4(false);
              }}
              onClose={(ret) => {
                state.setOpenModalTerms4(false);
              }}
            >
              <Container background="#e8eced" align="left" height="100%">
                {renderTerms4()}
              </Container>
            </Modal>

            <Loading open={state.openLoading} message={getDic("carregando")} />

            <ShowZendesk />
          </div>
          {renderModalNovartis()}
        </div>
      </FormColumn>
    </Container>
  );

  function renderTerms() {
    if (state.terms) {
      if (state.isIframeTerms) {
        return <IframePlayer height="80vh" src={state.terms} />;
      } else {
        return (
          <div style={{ maxHeight: '500px' }} dangerouslySetInnerHTML={{ __html: state.terms }} />
        );
      }
    } else {
      return (
        <div style={{ maxHeight: '500px' }}>
          <DefaultTerm />
        </div>
      );
    }
  }

  function renderTerms2() {
    if (state.terms2) {
      if (state.isIframeTerms2) {
        return <IframePlayer height="80vh" src={state.terms2} />;
      } else {
        return (
          <div style={{ maxHeight: '500px' }} dangerouslySetInnerHTML={{ __html: state.terms2 }} />
        );
      }
    } else {
      return (
        <div style={{ maxHeight: '500px' }}>
          <DefaultTerm />
        </div>
      );
    }
  }

  function renderTerms3() {
    if (state.terms3) {
      if (state.isIframeTerms3) {
        return <IframePlayer height="80vh" src={state.terms3} />;
      } else {
        return (
          <div style={{ maxHeight: '500px' }} dangerouslySetInnerHTML={{ __html: state.terms3 }} />
        );
      }
    } else {
      return (
        <div style={{ maxHeight: '500px' }}>
          <DefaultTerm />
        </div>
      );
    }
  }

  function renderTerms4() {
    if (state.terms4) {
      if (state.isIframeTerms4) {
        return <IframePlayer height="80vh" src={state.terms4} />;
      } else {
        return (
          <div style={{ maxHeight: '500px' }} dangerouslySetInnerHTML={{ __html: state.terms4 }} />
        );
      }
    } else {
      return (
        <div style={{ maxHeight: '500px' }}>
          <DefaultTerm />
        </div>
      );
    }
  }

  function renderTermsField() {
    return (
      <>
        {state.terms && (
          <>
            <br />
            <FormRow align="center">
              <Link color={state.tittle003.color}>
                <TextMedium
                  color={state.tittle003.color}
                  fontSize={state.tittle003.size}
                  fontWeight="bold"
                  onClick={() => {
                    state.setOpenModalTerms(true);
                    state.setTermsCheckboxDisabled(false);
                  }}
                >
                  {state.tittle003.text}
                </TextMedium>
              </Link>
            </FormRow>
            <FormRow align="center" margin="0px">
              {state.isComboboxTerms ? (
                <FormRow align="center" margin="0px">
                  <div style={{ paddingTop: 12, paddingRight: 5 }}>
                    <TextMedium
                      fontWeight="bold"
                      textColor={state.tittle004.color}
                      fontSize={state.tittle004.size}
                    >
                      {state.tittle004.text}
                    </TextMedium>
                  </div>
                  <SelectList
                    width="100px"
                    value={state.checkAuthorization}
                    menuItens={[
                      { text: getDic("nao"), value: false },
                      { text: getDic("sim"), value: true }
                    ]}
                    onChange={async (event) => {
                      state.setCheckAuthorization(event.target.value)
                    }}
                  />
                </FormRow>
              ) : (
                <Checkbox
                  text={state.tittle004.text}
                  textColor={state.tittle004.color}
                  fontSize={state.tittle004.size}
                  checked={state.checkAuthorization}
                  disabled={state.termsCheckboxDisabled}
                  fontWeight="bold"
                  onChange={() => {
                    if (state.autoOpenTerms) {
                      if (!state.termsCheckboxDisabled && !state.checkAuthorization) {
                        state.setOpenModalTerms(true);
                        state.setTermsCheckboxDisabled(false);
                      }
                      state.setCheckAuthorization(state.checkAuthorization === true ? false : true);
                    } else {
                      if (!state.termsCheckboxDisabled) {
                        state.setCheckAuthorization(state.checkAuthorization === true ? false : true);
                      }
                      else {
                        state.setAlertTitle(getDic('atencao'));
                        state.setAlertMessage(`${getDic("necessario")} ${getDic("ler")} ${getDic("termos")}`);
                        state.setAlertOpen(true);
                      }
                    }
                  }}
                />
              )}
            </FormRow>
          </>
        )}
      </>
    )
  }

  function renderTermsField2() {
    return (
      <>
        {state.terms2.hasTerm && (
          <>
            <br />
            <FormRow align="center" margin="0px">
              {state.isComboboxTerms2 ? (
                <>
                  <FormRow align="center">
                    <Link color={state.terms2.color}>
                      <TextMedium
                        color={state.terms2.color}
                        fontSize={state.terms2.size}
                        fontWeight="bold"
                        onClick={() => {
                          state.setOpenModalTerms2(true);
                          state.setTermsCheckboxDisabled2(false);
                        }}
                      >
                        {state.terms2.tooltip}
                      </TextMedium>
                    </Link>
                  </FormRow>
                  <FormRow align="center" margin="0px">
                    <div style={{ paddingTop: 12, paddingRight: 5 }}>
                      <TextMedium
                        fontWeight="bold"
                        color={state.terms2.color}
                        fontSize={state.terms2.size}
                      >
                        {state.terms2.tooltip}
                      </TextMedium>
                    </div>
                    <SelectList
                      width="100px"
                      value={state.terms2.checkAuthorization}
                      menuItens={[
                        { text: getDic("nao"), value: false },
                        { text: getDic("sim"), value: true }
                      ]}
                      onChange={(e) => {
                        state.setTerms2({ ...state.terms2, value: e.target.value });
                        functions.onChangeHandler(parseInt(state.terms2.termId), e.target.value === true ? 'Sim' : 'Não');
                      }}
                    />
                  </FormRow>
                </>
              ) : (
                <Checkbox
                  text={state.terms2.tooltip}
                  color={state.terms2.color}
                  fontSize={state.terms2.size}
                  checked={state.terms2.checkAuthorization}
                  // disabled={state.terms2.termsCheckboxDisabled}
                  fontWeight="bold"
                  onChange={() => {
                    state.setTerms2({ ...state.terms2, checkAuthorization: !state.terms2.checkAuthorization });
                    functions.onChangeHandler(parseInt(state.terms2.termId), !state.terms2.checkAuthorization === true ? 'Sim' : 'Não');
                  }}
                />
              )}
            </FormRow>
          </>
        )}
      </>
    )
  }

  function renderTermsField3() {
    return (
      <>
        {state.terms3.hasTerm && (
          <>
            <br />
            <FormRow align="center" margin="0px">
              {state.isComboboxTerms3 ? (
                <>
                  <FormRow align="center">
                    <Link color={state.terms3.color}>
                      <TextMedium
                        color={state.terms3.color}
                        fontSize={state.terms3.size}
                        fontWeight="bold"
                        onClick={() => {
                          state.setOpenModalTerms3(true);
                          state.setTermsCheckboxDisabled3(false);
                        }}
                      >
                        {state.terms3.tooltip}
                      </TextMedium>
                    </Link>
                  </FormRow>
                  <FormRow align="center" margin="0px">
                    <div style={{ paddingTop: 12, paddingRight: 5 }}>
                      <TextMedium
                        fontWeight="bold"
                        color={state.terms3.color}
                        fontSize={state.terms3.size}
                      >
                        {state.terms3.tooltip}
                      </TextMedium>
                    </div>
                    <SelectList
                      width="100px"
                      value={state.terms3.checkAuthorization}
                      menuItens={[
                        { text: getDic("nao"), value: false },
                        { text: getDic("sim"), value: true }
                      ]}
                      onChange={(e) => {
                        state.setTerms3({ ...state.terms3, value: e.target.value });
                        functions.onChangeHandler(parseInt(state.terms3.termId), e.target.value === true ? 'Sim' : 'Não');
                      }}
                    />
                  </FormRow>
                </>
              ) : (
                <Checkbox
                  text={state.terms3.tooltip}
                  color={state.terms3.color}
                  fontSize={state.terms3.size}
                  checked={state.terms3.checkAuthorization}
                  // disabled={state.terms3.termsCheckboxDisabled}
                  fontWeight="bold"
                  onChange={() => {
                    state.setTerms3({ ...state.terms3, checkAuthorization: !state.terms3.checkAuthorization });
                    functions.onChangeHandler(parseInt(state.terms3.termId), !state.terms3.checkAuthorization === true ? 'Sim' : 'Não');
                  }}
                />
              )}
            </FormRow>
          </>
        )}
      </>
    )
  }

  function renderTermsField4() {
    return (
      <>
        {state.terms4.hasTerm && (
          <>
            <br />
            <FormRow align="center" margin="0px">
              {state.isComboboxTerms4 ? (
                <>
                  <FormRow align="center">
                    <Link color={state.terms4.color}>
                      <TextMedium
                        color={state.terms4.color}
                        fontSize={state.terms4.size}
                        fontWeight="bold"
                        onClick={() => {
                          state.setOpenModalTerms4(true);
                          state.setTermsCheckboxDisabled4(false);
                        }}
                      >
                        {state.terms4.tooltip}
                      </TextMedium>
                    </Link>
                  </FormRow>
                  <FormRow align="center" margin="0px">
                    <div style={{ paddingTop: 12, paddingRight: 5 }}>
                      <TextMedium
                        fontWeight="bold"
                        color={state.terms4.color}
                        fontSize={state.terms4.size}
                      >
                        {state.terms4.tooltip}
                      </TextMedium>
                    </div>
                    <SelectList
                      width="100px"
                      value={state.terms4.checkAuthorization}
                      menuItens={[
                        { text: getDic("nao"), value: false },
                        { text: getDic("sim"), value: true }
                      ]}
                      onChange={(e) => {
                        state.setTerms4({ ...state.terms4, value: e.target.value });
                        functions.onChangeHandler(parseInt(state.terms4.termId), e.target.value === true ? 'Sim' : 'Não');
                      }}
                    />
                  </FormRow>
                </>
              ) : (
                <Checkbox
                  text={state.terms4.tooltip}
                  color={state.terms4.color}
                  fontSize={state.terms4.size}
                  checked={state.terms4.checkAuthorization}
                  // disabled={state.terms4.termsCheckboxDisabled}
                  fontWeight="bold"
                  onChange={() => {
                    state.setTerms4({ ...state.terms4, checkAuthorization: !state.terms4.checkAuthorization });
                    functions.onChangeHandler(parseInt(state.terms4.termId), !state.terms4.checkAuthorization === true ? 'Sim' : 'Não');
                  }}
                />
              )}
            </FormRow>
          </>
        )}
      </>
    )
  }
}

export default RegistrationPageVisual;
